<template>
  <div class="HKIndex">
    <div class="banner">
      <div class="top" ref="topref">
        <Header></Header>
      </div>
      <swiper :options="swiperOptions">
        <swiper-slide v-for="(ele, n) in bannerlist" :key="n"
          >
          <div class="swiper-container">
            <HKIndexPage :list="ele" :index="n + 1"></HKIndexPage></div
        >
      </swiper-slide>
      </swiper>
    </div>
    <div class="custom-pagination"></div>

    <!-- 二级菜单 -->
    <div class="bottom_menu" ref="menuRef">
      <div class="hkjr"></div>
      <div class="menu_box">
        <div
          class="se_item"
          :class="$route.path.includes(ele.path) ? 'se_item_active' : ''"
          @click="pageto(ele.path)"
          v-for="(ele, n) in menulist"
          :key="n"
        >
          <div class="text">{{ ele.name }}</div>
          <div class="border"></div>
        </div>
      </div>

      <div class="about_hk" ref="btnRef"></div>
      <div class="menu_hk" @click="openm" ref="menu"></div>
    </div>
    <!-- 二级菜单主体试图层 -->
    <div class="main">
      <router-view />
    </div>

    <Dialog ref="dialog"></Dialog>
  </div>
</template>

  <script>
import banner1 from "@/assets/banner/banner_01.png";
import banner2 from "@/assets/banner/banner_02.png";
import banner3 from "@/assets/banner/banner_03.png";
import banner4 from "@/assets/banner/banner_04.png";
import HKIndexPage from "@/components/HKIndex_page.vue";
import Dialog from "@/components/dialog.vue";
import Header from "@/components/header.vue";
import { swiperAnimate, swiperAnimateCache } from "@/utils/animate.js";
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    Swiper,
    SwiperSlide,
    Header,
    HKIndexPage,
    Dialog,
  },
  data() {
    return {
      documentTitle:'关于华科',
      deep: 0,
      menulist: [
        { name: "公司概况", path: "/aboutHK/introduce" },
        { name: "企业文化", path: "/aboutHK/enterpriseCul" },
        { name: "大事记", path: "/aboutHK/events" },
        { name: "经典案例", path: "/aboutHK/case" },
        { name: "社会荣誉", path: "/aboutHK/social" },
      ],
      bannerlist: [
        {
          bg: banner3,
          text: {
            cn: '科技',
            en: 'INDUSTRIAL FINANCE'
          },
        },
        {
          bg: banner2,
          text: {
            cn: '产业',
            en: 'INDUSTRIAL FINANCE'
          },
        },
        {
          bg: banner4,
          text: {
            cn: '资产',
            en: 'ASSET FINANCE'
          },
        },
        {
          bg: banner1,
          text: {
            cn: '创新',
            en: 'INNOVATIVE FINANCE'
          },
        },
      ],
      swiperOptions: {
        pagination: {
          el: ".custom-pagination",
          clickable: true,
        },
        direction: "horizontal",
        autoplay: true,
        parallax: true,
        // 环路
        loop: false,
        effect: "fade",
        cubeEffect: {
          slideShadows: true,
          shadow: true,
          shadowOffset: 100,
          shadowScale: 0.7,
        },
        on: {
          init: function () {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionStart: function () {},
          slideChangeTransitionEnd: function () {},
          slideChange: function () {
            swiperAnimate(this);
          },
        },
      },
    };
  },
  watch: {
    "$route.query": {
      handler(val) {
        this.deep = Number(val.deep);
        if (!isNaN(this.deep)) {
          window.scrollTo({
            top: this.deep,
            behavior: "instant",
          });
        }
      },
      immediate: true,
    },
    '$route': {
      handler: function(route) {
        if (route.meta && route.meta.title) {
          this.setDocumentTitle(route.meta.title);
        }
      },
      immediate: true
    }
  },
  methods: {
    setDocumentTitle(title) {
      document.title = title;
    },
    openm() {
      this.$refs.dialog.open();
    },
    pageto(path) {
      this.$router.push(path).catch(error=>{
        console.log(error);
      });
        window.scrollTo({
          top: 901,
          behavior: "instant",
        });
    },
    scroll() {
      let _this = this;
      window.addEventListener("scroll", function () {
        if (window.scrollY > 100 && _this.$refs.topref) {
          _this.$refs.topref.style.background = "rgba(255, 255, 255, 1)";
        }

        if (window.scrollY > 890 && _this.$refs.topref && _this.$refs.menuRef) {
          _this.$refs.topref.style.height = "0";
          _this.$refs.menuRef.style.position = "fixed";
          _this.$refs.menuRef.style.left = "0";
          _this.$refs.menuRef.style.top = "0";
          _this.$refs.menuRef.style.zIndex = "99";
          _this.$refs.btnRef.style.display = "none";
          _this.$refs.menu.style.display = "block";
        }

        if (window.scrollY < 890 && _this.$refs.topref) {
          _this.$refs.topref.style.height = "6.25rem";
          _this.$refs.menuRef.style.position = "static";
          _this.$refs.menuRef.style.marginBottom = "0";
          _this.$refs.btnRef.style.display = "block";
          _this.$refs.menu.style.display = "none";
        }

        if (window.scrollY <= 100 && _this.$refs.topref) {
          _this.$refs.topref.style.background = "rgba(255, 255, 255, 0)";
        }
      });
    },
  },
  mounted() {
    this.scroll();
  },
};
</script>
  
  <style scoped lang="scss">
.HKIndex {
  width: 100%;
  height: 100%;
  background: rgba($color: #fff, $alpha: 1);
  text-align: center;
}

.bottom_menu {
  width: 100%;
  height: 100px;
  background: #fff;
  padding: 0 88px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow:  0px 0px 6px #eee;
  .hkjr {
    width: 183px;
    height: 20px;
    background: url("../../assets/menu/hkjy.png") no-repeat;
    background-size: 183px 20px;
  }
  .menu_box {
    width: 1200px;
    display: flex;
  }
  .se_item {
    height: 45px;
    padding-top: 10px;
    margin: 0 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* 标准语法 */
    cursor: pointer;
  }
  .se_item_active {
    color: #d42424;
    font-weight: 700;
    .border {
      width: 24px;
      height: 3px;
      background: #d42424;
    }
  }
  .about_hk {
    width: 326px;
    height: 29px;
    background: url("../../assets/menu/abhk.png") no-repeat;
    background-size: 326px 29px;
  }
  .menu_hk {
    width: 23px;
    height: 15px;
    background: url("../../assets/menu/header_icon.png") no-repeat;
    background-size: 23px 15px;
    display: none;
    cursor: pointer;
  }
}

.banner {
  width: 100%;
  height: 100%;
  .swiper-container {
    width: 100%;
    height: 100%;
  }
  .top {
    width: 100%;
    height: 100px;
    // overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    transition: all 1s;
  }
}

.main {
  width: 100%;
  // height: 100%;
  box-sizing: border-box;
}

.custom-pagination {
  width: 150px;
  height: 114px;
  display: flex;
  align-items: center;
  position: absolute;
  right: 88px;
  z-index: 20;
  bottom: 37px;
}

:deep(.swiper-pagination-bullet) {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #fff;
  border-radius: 50%;
  margin: 0 7px;
  cursor: pointer;
  overflow: hidden;
}
:deep(.swiper-pagination-bullet-active) {
  width: 23px;
  height: 23px;
  background: url("../../assets/banner/pagination.png") no-repeat;
  background-size: 23px 23px;
}
</style>